export default __webpack_public_path__ + "static/media/chakraui.ff5f2ef2.png";